<template>
  <transition
    :name="transitionType"
    :mode="transitionMode"
    :enter-active-class="transitionEnterActiveClass"
    @beforeLeave="beforeLeave"
    @enter="enter"
    @afterEnter="afterEnter">
    <slot/>
  </transition>
</template>

<script>
export const types = {
  FADE: 'fade',
  SLIDE: 'slide',
  SLIDE_LEFT: 'slide-left',
  SLIDE_RIGHT: 'slide-right',
  SCROLL: 'scroll',
  SCROLL_UP: 'scroll-up',
  SCROLL_DOWN: 'scroll-down',
  ZOOM: 'zoom'
}

export const modes = {
  OUT_IN: 'out-in',
  IN_OUT: 'in-out'
}

const DEFAULT_TRANSITION = types.FADE
const DEFAULT_TRANSITION_MODE = modes.OUT_IN

export default {
  name: 'PageTransition',
  data () {
    return {
      prevHeight: 0,
      transitionType: DEFAULT_TRANSITION,
      transitionMode: DEFAULT_TRANSITION_MODE,
      transitionEnterActiveClass: ''
    }
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      let transitionType = to.meta.transitionType || from.meta.transitionType || DEFAULT_TRANSITION
      if (typeof transitionType === 'function') {
        transitionType = transitionType(to, from) || DEFAULT_TRANSITION
      }

      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length

      if (transitionType === types.SLIDE) {
        transitionType = toDepth < fromDepth ? types.SLIDE_RIGHT : types.SLIDE_LEFT
      }

      if (transitionType === types.SCROLL) {
        transitionType = toDepth < fromDepth ? types.SLIDE_RIGHT : types.SLIDE_LEFT
      }

      this.transitionMode = DEFAULT_TRANSITION_MODE
      this.transitionEnterActiveClass = `${transitionType}-enter-active`

      if (to.meta.transitionType === types.ZOOM) {
        this.transitionMode = modes.IN_OUT
        this.transitionEnterActiveClass = 'zoom-enter-active'
        document.body.style.overflow = 'hidden'
      }

      if (from.meta.transitionType === types.ZOOM) {
        this.transitionMode = null
        this.transitionEnterActiveClass = null
        document.body.style.overflow = null
      }

      this.transitionType = transitionType

      next()
    })
  },
  methods: {
    beforeLeave (element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter (element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter (element) {
      element.style.height = 'auto'
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.4s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

.scroll-up-enter-active,
.scroll-up-leave-active,
.scroll-down-enter-active,
.scroll-down-leave-active {
  transition-duration: 0.4s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.scroll-up-enter,
.scroll-down-leave-active {
  opacity: 0;
  transform: translate(0, 2em);
}

.scroll-up-leave-active,
.scroll-down-enter {
  opacity: 0;
  transform: translate(0, -2em);
}

.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.4s;
  animation-fill-mode: both;
  animation-name: zoom;
}

.zoom-leave-active {
  animation-direction: reverse;
}

@keyframes zoom {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  100% {
    opacity: 1;
  }
}
</style>
